const SuccessIcon = (props) => <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 116 116" fill="none">
    <circle cx="58" cy="58" r="58" fill="currentColor" />
    <path d="M44.5781 57.245L53.7516 66.6843L70.6308 49.3159" stroke="white" strokeWidth="4" strokeLinecap="round" />
</svg>;

export default SuccessIcon;